module.exports = __webpack_public_path__ + "img/shouru.fea98571.png";